import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Megaphone } from "lucide-react";
import { api } from "@/lib/api";
import { SEEN_KEY } from "@/lib/siteNews";

export const useNewsUnread = () => {
  const { data } = useQuery({ queryKey: ["news-latest"], queryFn: () => api.get("/site/news-latest").then((r) => r.data), staleTime: 600_000 });
  const [seen, setSeen] = useState(() => localStorage.getItem(SEEN_KEY) || "");
  useEffect(() => {
    const on = () => setSeen(localStorage.getItem(SEEN_KEY) || "");
    window.addEventListener("lf-news-seen", on);
    return () => window.removeEventListener("lf-news-seen", on);
  }, []);
  return !!(data?.at && data.at > seen);
};

export const WhatsNewLink = ({ className = "", testid = "whats-new-link" }) => {
  const unread = useNewsUnread();
  return (
    <Link to="/updates" className={`relative inline-flex items-center gap-1.5 hover:text-[#F3EBDD] ${className}`} data-testid={testid}>
      <Megaphone className="h-3.5 w-3.5" />What's new
      {unread && <span className="absolute -right-2 -top-1 h-2 w-2 rounded-full bg-[#F59E0B] shadow-[0_0_8px_#F59E0B]" data-testid={`${testid}-dot`} />}
    </Link>
  );
};
